import React, { useState, useContext, useEffect } from "react";
import {
    Stack,
    FormControl,
    useColorModeValue,
    GridItem,
    Heading,
    Text,
    Button,
    Flex,
    Select,
    Spinner,
    Grid,
    Center,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import { FiDownload } from "react-icons/fi";
import UserContext from "../State/UserContext";

export default function Padron() {
    const [loading, setLoading] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { user } = useContext(UserContext);
    const [validMonths, setValidMonths] = useState([]);

    useEffect(() => {
        const monthNames = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        const today = new Date();
        const months = [];

        // Empezamos desde el mes anterior al actual
        const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);

        for (let i = 0; i < 12; i++) {
            const date = new Date(start.getFullYear(), start.getMonth() - i, 1);
            months.push({
                month: monthNames[date.getMonth()],
                year: date.getFullYear()
            });
        }

        setValidMonths(months.reverse()); // Orden cronológico
    }, []);

    const availableYears = Array.from(new Set(validMonths.map(item => item.year)));

    const filteredMonths = validMonths
        .filter(item => parseInt(selectedYear) === item.year)
        .map(item => item.month);


    async function handleDownload() {
        if (!selectedYear || !selectedMonth || selectedYear === "" || selectedMonth === "") {
            setErrorMessage("Por favor seleccione un mes y un año");
            return;
        }

        setErrorMessage(""); 
        setLoading(true);

        try {
            const response = await fetch("provider/getPadron?month=" + selectedMonth + "&year=" + selectedYear + "&email=" + encodeURIComponent(user.user.email), {
                method: 'POST',
                headers: { "Content-Type": "application/json", "userToken": user.token }
            });

            if (response.ok) {
                const blob = await response.blob();

                // Obtener y limpiar el nombre del archivo desde Content-Disposition
                const contentDisposition = response.headers.get("Content-Disposition");
                if (!contentDisposition) {
                    throw new Error("No se encontró el encabezado Content-Disposition");
                }

                // Extraer el nombre del archivo y eliminar caracteres no deseados
                const match = contentDisposition.match(/filename\*?=["']?(?:UTF-8''|)([^;"\n]+)/);
                if (!match || !match[1]) {
                    throw new Error("No se pudo extraer el nombre del archivo correctamente");
                }

                const filename = match[1].trim(); // Eliminar espacios extra

                // Crear y descargar el archivo con el nombre correcto
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                let message = "No se pudo descargar el archivo.";
                try {
                    const errorData = await response.json();
                    if (errorData?.message) {
                        message = errorData.message;
                    }
                } catch {
                    // Si no hay JSON en la respuesta, dejamos el mensaje por defecto
                
                }
                setErrorMessage(message);
            }
        } catch (error) {
            console.error("Error:", error);
        }

        setLoading(false);
    }


    return (
        <Flex height="100vh" alignItems="center" justifyContent="center" backgroundColor="gray.100">
            <Stack boxShadow="md" bg={useColorModeValue("white", "gray.600")} rounded={"xl"} p={10} spacing={8} align={"center"} w="xl">
                <Stack align={"center"} spacing={2}>
                    <Heading textTransform={"uppercase"} fontSize={"3xl"} color={useColorModeValue("gray.600", "gray.200")}>
                        DESCARGA DE PADRÓN
                    </Heading>
                    <Text textAlign="center" fontSize={"lg"} color={"gray.600"}>
                        Seleccione el mes y el año de descarga del padrón
                    </Text>
                </Stack>

                {errorMessage && (
                    <Alert status="error">
                        <AlertIcon />
                        {errorMessage}
                    </Alert>
                )}

                {/* Sección con los Select organizados en dos columnas */}
                <FormControl as={GridItem} colSpan={6}>
                    <Grid templateColumns="repeat(2, 1fr)" gap={6}> 
                        <Select
                            placeholder="Seleccione el mes"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            size="sm"
                            rounded="md"
                            shadow="sm"
                            focusBorderColor="brand.600"
                            isDisabled={!selectedYear}
                        >
                            {filteredMonths.map((month) => (
                                <option key={month} value={month}>
                                    {month}
                                </option>
                            ))}
                        </Select>

                        <Select
                            placeholder="Seleccione el año"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            size="sm"
                            rounded="md"
                            shadow="sm"
                            focusBorderColor="brand.600"
                            isDisabled={availableYears.length === 0}
                        >
                            {availableYears.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </Select>
                    </Grid>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <Button borderRadius="8px" variant="solid" color="#004990" width="full" onClick={() => handleDownload()} leftIcon={<FiDownload />} disabled={loading}>
                        {loading ? <Spinner color="#004990" /> : "Descargar"}
                    </Button>
                </FormControl>
            </Stack>
        </Flex>
    );
}
